import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import {
  FaArrowLeft,
  FaArrowRight,
  FaCheckCircle,
  FaShippingFast,
  FaHeadset,
  FaMoneyCheck,
} from "react-icons/fa";
import "./carrusel.css";

import slider1 from "../assets/slider1.png";
import slider2 from "../assets/slider2.png";
import slider3 from "../assets/slider3.png";
import slider4 from "../assets/slidernuevo.png";

const allies = [
  {
    img: "motobunker.jpg",
    url: "https://www.google.com.mx/maps/place/Motobunker+-+Vento+Laguna/@25.5190873,-103.3966944,18.1z/data=!4m6!3m5!1s0x868fdb8c5b1bd233:0xc24f782ea56264ee!8m2!3d25.5195259!4d-103.3959618!16s%2Fg%2F11wmwzd2lt?hl=es&entry=ttu&g_ep=EgoyMDI1MDYzMC4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    img: "alianza.jpg",
    url: "https://www.google.com/maps/search/construalianza/@25.5602599,-103.4707625,12z/data=!3m1!4b1?entry=ttu&g_ep=EgoyMDI1MDYzMC4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    img: "marcos.jpg",
    url: "https://www.google.com.mx/maps/place/Marcos+Mueblerias/@25.5371962,-103.4410153,17z/data=!4m6!3m5!1s0x868fd9606c19dae5:0x76426b78711fbfc!8m2!3d25.5370893!4d-103.4413178!16s%2Fg%2F1tfqltsj?hl=es&entry=ttu&g_ep=EgoyMDI1MDYzMC4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    img: "vikma.jpg",
    url: "https://www.google.com.mx/maps/place/Vikm%C3%A1+Home/@25.5689334,-103.5028469,17.67z/data=!4m6!3m5!1s0x868fd84c690429f1:0x86173ec899bce542!8m2!3d25.569049!4d-103.5013447!16s%2Fg%2F11gg65b8bz?hl=es&entry=ttu&g_ep=EgoyMDI1MDYzMC4wIKXMDSoASAFQAw%3D%3D",
  },
  { img: "eyd.jpeg",             url: "https://maps.app.goo.gl/6fzh9gXTnpWPf1Vp6" },
  { img: "bodegon.jpeg",         url: "https://maps.app.goo.gl/nMeXUvxS7eewawtLA" },
  { img: "launica.jpeg",         url: "https://maps.app.goo.gl/qSda6GYwn3KqRZSZ9" },
  { img: "nova.jpeg",            url: "https://maps.app.goo.gl/viDpXSQynKgGbeFFA" },
  { img: "supercolchones.jpeg",  url: "#" },
  { img: "muebleriatere.jpg",    url: "https://maps.app.goo.gl/XYKjigPqUkWBeDBP9" },
  { img: "lamsa.jpeg",           url: "https://maps.app.goo.gl/ocHZaF2b5TF1n7NAA" },
  { img: "logoadventure_260513_125034_page-0001.jpg", url: "https://maps.app.goo.gl/V8tTzZigsA4EtXs28" },
  { img: "harmony.jpg",          url: "https://maps.app.goo.gl/RKUtTjEtqS5kuf4B8?g_st=iw" },
  { img: "evobike.jpeg",         url: "https://www.google.com/maps?q=25.76102066040039,-102.989013671875&z=17&hl=es" },
  { img: "LOGO%20MONTIER.png",  url: "https://share.google/EERZ4J7CjevsAyzY9h" },
  { img: "ktm.jpg",             url: "https://www.ktm.com/es-mx.html" },
];

const PrevArrow = (props) => (
  <div className="aita-home-arrow aita-home-arrow-prev" onClick={props.onClick}>
    <FaArrowLeft />
  </div>
);

const NextArrow = (props) => (
  <div className="aita-home-arrow aita-home-arrow-next" onClick={props.onClick}>
    <FaArrowRight />
  </div>
);

const TickerPrev = (props) => (
  <div className="aita-ticker-arrow aita-ticker-arrow-prev" onClick={props.onClick}>
    <FaArrowLeft />
  </div>
);

const TickerNext = (props) => (
  <div className="aita-ticker-arrow aita-ticker-arrow-next" onClick={props.onClick}>
    <FaArrowRight />
  </div>
);

export const Carrusel = () => {
  useEffect(() => {
    document.title = 'AITA - Inicio';
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 900,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6500,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };

  const images = [slider1, slider2, slider3, slider4];

  const tickerSettings = {
    dots: false,
    infinite: true,
    speed: 700,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2200,
    arrows: true,
    prevArrow: <TickerPrev />,
    nextArrow: <TickerNext />,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 5 } },
      { breakpoint: 900,  settings: { slidesToShow: 4 } },
      { breakpoint: 600,  settings: { slidesToShow: 3 } },
    ],
  };

  return (
    <div className="aita-home">

      {/* TICKER DE ALIADOS */}
      <div className="aita-ticker">
        <div className="aita-ticker-inner">
          <span className="aita-ticker-label">Estrena fácil con tu crédito exprés AITA</span>
          <div className="aita-ticker-slider">
            <Slider {...tickerSettings}>
              {allies.map(({ img, url }) => (
                <div key={img} className="aita-ticker-slide">
                  <a href={url} target="_blank" rel="noopener noreferrer" className="aita-ticker-card">
                    <img src={`/${img}`} alt="aliado" className="aita-ticker-logo" />
                  </a>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>

      {/* HERO */}
      <section id="inicio" className="aita-home-hero">
        <div className="aita-home-hero-inner">
          {/* Columna izquierda: texto */}
          <div
            className="aita-home-hero-content"
            data-aos="fade-right"
            data-aos-once="true"
          >
            <p className="aita-home-hero-badge">
              Comercializadora & crédito expres
            </p>
            <h1 className="aita-home-hero-title">
              Estrena los productos que necesitas con pagos fijos y accesibles
            </h1>
            <p className="aita-home-hero-subtitle">
              En AITA te ayudamos a adquirir{" "}
              <strong>línea blanca, tecnología, muebles, construcción y más</strong>{" "}
              mediante crédito expres aplicado al producto que eliges, con
              acompañamiento personalizado de un asesor de ventas.
            </p>

            <ul className="aita-home-hero-bullets">
              <li>
                <FaCheckCircle />
                <span>Proceso de autorización ágil y requisitos claros.</span>
              </li>
              <li>
                <FaCheckCircle />
                <span>Pagos fijos durante todo el plazo del crédito.</span>
              </li>
              <li>
                <FaCheckCircle />
                <span>Atención cercana antes, durante y después de tu compra.</span>
              </li>
            </ul>

            <div className="aita-home-hero-actions">
              <Link to="/asesores" className="aita-home-btn aita-home-btn-primary">
                Hablar con un asesor
              </Link>
              <Link
                to="/productos"
                className="aita-home-btn aita-home-btn-secondary"
              >
                Ver catálogo de productos
              </Link>
            </div>
          </div>

          {/* Columna derecha: slider */}
          <div
            className="aita-home-hero-media"
            data-aos="fade-left"
            data-aos-once="true"
          >
            <div className="aita-home-carousel-wrapper">
              <Slider {...settings}>
                {images.map((src, idx) => (
                  <div key={idx}>
                    <img
                      src={src}
                      alt={`Promoción ${idx + 1}`}
                      className="aita-home-carousel-image"
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>

        {/* Frase/banner */}
        <div
          className="aita-home-tagline"
          data-aos="zoom-in"
          data-aos-once="true"
        >
          <img
            src="/frase2-2048x477.png"
            alt="Tenemos los mejores productos para ti"
            className="aita-home-tagline-img"
          />
        </div>

        {/* Stats rápidos */}
        <div className="aita-home-stats">
          <div className="aita-home-stat">
            <span className="aita-home-stat-number">+ Líneas de producto</span>
            <p className="aita-home-stat-label">
              Electrodomésticos, tecnología, muebles y más.
            </p>
          </div>
          <div className="aita-home-stat">
            <span className="aita-home-stat-number">Crédito sobre producto</span>
            <p className="aita-home-stat-label">
              Pagas en cómodas parcialidades tu compra.
            </p>
          </div>
          <div className="aita-home-stat">
            <span className="aita-home-stat-number">Atención personalizada</span>
            <p className="aita-home-stat-label">
              Asesores que te acompañan en todo el proceso.
            </p>
          </div>
        </div>
      </section>

      {/* CÓMO FUNCIONA */}
      <section
        id="como-funciona"
        className="aita-home-section aita-home-how"
        data-aos="fade-up"
        data-aos-once="true"
      >
        <h2 className="aita-home-section-title">¿Cómo funciona?</h2>
        <p className="aita-home-section-subtitle">
          El proceso es sencillo: un asesor te guía en cada paso para que
          conozcas tus opciones y estrenes tus productos sin complicaciones.
        </p>

        <div className="aita-home-how-steps">
          <div className="aita-home-step">
            <div className="aita-home-step-number">1</div>
            <h3>Contacta a tu asesor</h3>
            <p>
              Acércate a tu asesor AITA o solicita que te contacten para conocer
              requisitos y planes de pago disponibles.
            </p>
          </div>
          <div className="aita-home-step">
            <div className="aita-home-step-number">2</div>
            <h3>Elige tus productos</h3>
            <p>
              Revisa el catálogo vigente, compara opciones y selecciona los
              productos que mejor se adaptan a tus necesidades.
            </p>
          </div>
          <div className="aita-home-step">
            <div className="aita-home-step-number">3</div>
            <h3>Autorización y entrega</h3>
            <p>
              Tu crédito se revisa, se firma el contrato y coordinamos la
              entrega de tus productos para que solo te preocupes por disfrutarlos.
            </p>
          </div>
        </div>
      </section>

      {/* LÍNEAS DE PRODUCTO */}
      <section
        id="productos"
        className="aita-home-section aita-home-categories"
        data-aos="fade-up"
        data-aos-once="true"
      >
        <h2 className="aita-home-section-title">Líneas de producto</h2>
        <p className="aita-home-section-subtitle">
          Contamos con productos para tu hogar, familia y estilo de vida, a
          través de nuestros aliados comerciales.
        </p>

        <div className="aita-home-categories-grid">
          {[
            { src: "/lineaBlanca.png",   label: "Línea blanca", aos: "fade-right" },
            { src: "/tecnologia.png",    label: "Tecnología",   aos: "fade-down"  },
            { src: "/Cconstruccion.png", label: "Construcción", aos: "fade-up"    },
            { src: "/muebles.png",       label: "Muebles",      aos: "fade-left"  },
          ].map(({ src, label, aos }) => (
            <Link
              key={label}
              to="/productos"
              className="aita-home-category-card"
              data-aos={aos}
              data-aos-once="true"
            >
              <img src={src} alt={label} className="aita-home-category-img" />
              <span className="aita-home-category-label">{label}</span>
            </Link>
          ))}
        </div>
      </section>

      {/* VIDEO CORPORATIVO */}
      <section
        className="aita-home-video-wrapper"
        style={{ backgroundImage: "url('/videobackground.png')" }}
      >
        <div
          className="aita-home-video-container"
          data-aos="zoom-in-up"
          data-aos-once="true"
        >
          <video className="aita-home-video" controls>
            <source src="/aita-video-insta.mp4" type="video/mp4" />
            Tu navegador no soporta la reproducción de video.
          </video>
        </div>
      </section>

      {/* FONDO VERDE: ALIANZAS, BENEFICIOS, TESTIMONIOS */}
      <section className="aita-home-bg-section">
        {/* ALIANZAS */}
        <div
          id="alianzas"
          className="aita-home-section aita-home-allies"
          data-aos="fade-up"
          data-aos-once="true"
        >
          <h2 className="aita-home-section-title">Alianzas comerciales</h2>
          <p className="aita-home-allies-legend">
            Utiliza tu crédito <span className="aita-home-highlight">AITA</span>{" "}
            en cualquiera de nuestros aliados comerciales autorizados.
          </p>

          <div className="aita-home-allies-grid">
            {allies.map(({ img, url }) => (
              <a
                key={img}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="aita-home-ally-card"
              >
                <img
                  src={`/${img}`}
                  alt={`Logo aliado`}
                  className="aita-home-ally-logo"
                />
              </a>
            ))}
          </div>
        </div>

        {/* BENEFICIOS / POR QUÉ NOSOTROS */}
        <div
          className="aita-home-section aita-home-why"
          data-aos="fade-up"
          data-aos-once="true"
        >
          <h2 className="aita-home-section-title">
            Beneficios de nuestro crédito
          </h2>
          <p className="aita-home-section-subtitle">
            Nuestro modelo de crédito sobre producto está diseñado para que
            tengas claridad en pagos, respaldo y atención cercana.
          </p>

          <div className="aita-home-why-items">
            <div className="aita-home-why-item">
              <FaMoneyCheck className="aita-home-why-icon" />
              <h3>Pagos Competitivos</h3>
              <p>
                Las mejores ofertas sin sacrificar calidad ni servicio.
              </p>
            </div>
            <div className="aita-home-why-item">
              <FaCheckCircle className="aita-home-why-icon" />
              <h3>Claridad y transparencia</h3>
              <p>
                Sin letras chiquitas: tu asesor te explica condiciones, plazos y
                requisitos antes de firmar.
              </p>
            </div>
            <div className="aita-home-why-item">
              <FaShippingFast className="aita-home-why-icon" />
              <h3>Envio Rápido</h3>
              <p>
                Envio gratis en cualquiera de nuestros productos sin monto
                mínimo de compra.
              </p>
            </div>
            <div className="aita-home-why-item">
              <FaHeadset className="aita-home-why-icon" />
              <h3>Atención Personalizada</h3>
              <p>Soporte al cliente siempre disponible.</p>
            </div>
          </div>
        </div>

        {/* TESTIMONIOS */}
        <div
          id="testimonios"
          className="aita-home-section aita-home-testimonials"
          data-aos="fade-up"
          data-aos-once="true"
        >
          <h2 className="aita-home-section-title">
            Lo que dicen nuestros clientes
          </h2>
          <div className="aita-home-testimonials-list">
            <article className="aita-home-testimonial">
              <p className="aita-home-quote">
                Visité la exhibición en busca de un minisplit y tenía dudas por
                mi antigüedad laboral. El asesor me explicó el Crédito Exprés,
                ingresó mi solicitud y en minutos ya estaba aprobado. Ese mismo
                día firmé y me entregaron el equipo sin contratiempos. La
                rapidez del trámite y la atención hicieron que recomendara el
                servicio a mis compañeros.
              </p>
              <h4 className="aita-home-author">— Esteban Carrillo</h4>
            </article>

            <article className="aita-home-testimonial">
              <p className="aita-home-quote">
                En una sola visita pudimos adquirir un aire acondicionado y un
                colchón para nuestro hijo. Nos explicaron claramente el crédito,
                firmamos y los productos quedaron listos para entrega. Cuando
                termine de pagar, regresaré para renovar mi motocicleta gracias
                a la facilidad de pago.
              </p>
              <h4 className="aita-home-author">
                — Uriel, Paramédico de la Cruz Roja
              </h4>
            </article>

            <article className="aita-home-testimonial">
              <p className="aita-home-quote">
                Necesitaba dos celulares como regalo de graduación para mis
                hijos y además apoyo con el empaque. La vendedora se encargó de
                todo, desde la gestión del crédito hasta envolver los equipos.
                Pude llegar directo al evento y entregar los regalos tal como lo
                había planeado.
              </p>
              <h4 className="aita-home-author">— Ana Cortéz</h4>
            </article>
          </div>
        </div>
      </section>

      {/* CONTACTO / CTA FINAL */}
      <section
        id="contacto"
        className="aita-home-section aita-home-contact"
        data-aos="fade-up"
        data-aos-once="true"
      >
        <div className="aita-home-contact-inner">
          <div>
            <h2 className="aita-home-contact-title">
              ¿Listo para estrenar con crédito AITA?
            </h2>
            <p className="aita-home-contact-text">
              Ponte en contacto con un asesor de ventas para conocer las
              opciones de crédito disponibles y los productos del catálogo
              vigente.
            </p>
          </div>
          <div className="aita-home-contact-actions">
            <a
  href="https://wa.me/52871357094?text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20cr%C3%A9dito%20AITA."
  target="_blank"
  rel="noopener noreferrer"
  className="aita-home-btn aita-home-btn-primary"
>
  Encontrar asesor
</a>
            <Link
              to="/estado-cuenta"
              className="aita-home-btn aita-home-btn-outline"
            >
              Consultar mi crédito
            </Link>
          </div>
        </div>
      </section>
      {/* Tu footer va aparte */}
    </div>
  );
};
